import { isBrowser } from "@okta/okta-auth-js/cjs/features";

export const getParams = (matcher, endpointStart) => {
  if (!isBrowser())
    return {};
  
  let scripts = document.getElementsByTagName("script");
  let regex = new RegExp(matcher);
  for (let i = 0; i < scripts.length; i++) {
    if (regex.test(scripts[i].src)) {
      return getParamsFromURL(scripts[i].src, endpointStart);
    }
  }

  return {};
};

export const getParamsFromURL = (url, endpointStart) => {
  let params = {};

  if (!url || url === "")
    return params;
  
  let domain = (String(url) || "").split(endpointStart)[0];

  let rawParams = (String(url) || "")
    .split("?")
    .pop()
    .split("&");

  rawParams.forEach((item) => {
    let [key, value] = item.split("=");
    if (key && value)
      params[key] = value;
  });

  params['domain'] = domain;
  return params;
};
